import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withKeys as _withKeys, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-2"
}
const _hoisted_2 = { class: "d-flex align-items-center justify-content-between mb-1" }
const _hoisted_3 = { class: "text-muted fw-semibold" }
const _hoisted_4 = { class: "border" }
const _hoisted_5 = { class: "table table-sm mb-0 align-middle" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "table-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"width":"60px"} }, "#"),
    /*#__PURE__*/_createElementVNode("th", null, "Detalle"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"90px"},
      class: "text-end"
    }, "Acción")
  ])
], -1)
const _hoisted_7 = { class: "fw-semibold" }
const _hoisted_8 = { class: "fw-semibold" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", {
  class: "spinner-border spinner-border-sm me-2",
  role: "status",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_11 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_12 = {
  key: 0,
  class: "fw-semibold"
}

import { ref, watch, computed, onMounted, onBeforeUnmount } from 'vue';

type OptionItem = { value: any; text: string };


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiSearchSelect',
  props: {
    modelValue: {},
    options: {},
    placeholder: {},
    required: { type: Boolean },
    invalidMessage: {},
    wasValidated: { type: Boolean },
    disabled: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["update:modelValue", "change"],
  setup(__props: any, { emit }) {

const props = __props;





const rootEl = ref<HTMLElement | null>(null);
const searchTerm = ref('');
const isOpen = ref(false);
const activeIndex = ref(-1);
const listId = `ac-${Math.random().toString(36).slice(2)}`;
const touched = ref(false);

// Validation
const showErrors = computed(() => props.wasValidated === true || touched.value);
const isInvalid = computed(() => !!props.required && showErrors.value && (!props.modelValue || props.modelValue.length === 0));
const inputState = computed<null | boolean>(() => (isInvalid.value ? false : null));
const invalidText = computed(() => props.invalidMessage || 'Campo requerido');

// Filtering
const filteredOptions = computed<OptionItem[]>(() => {
  const term = searchTerm.value.trim().toLowerCase();
  const list = props.options || [];
  if (!term) return list;
  return list.filter(o => (o.text || '').toLowerCase().includes(term));
});

// Selected rows for table
const selectedRows = computed<OptionItem[]>(() => {
  const values = Array.isArray(props.modelValue) ? props.modelValue : [];
  return values.map(v => props.options?.find(o => o.value === v) || ({ value: v, text: `ID: ${String(v)}` }));
});

const showList = computed(() => isOpen.value && !props.disabled);

function isSelected(val: any) {
  return Array.isArray(props.modelValue) && props.modelValue.some(x => x === val);
}

// Actions
function open() {
  if (props.disabled) return;
  isOpen.value = true;
}

function close() {
  isOpen.value = false;
  activeIndex.value = -1;
}

function onInput() {
  open();
  activeIndex.value = 0;
}

function selectOption(option: OptionItem) {
  const current = Array.isArray(props.modelValue) ? props.modelValue : [];
  if (!current.some(v => v === option.value)) {
    const next = [...current, option.value];
    emit('update:modelValue', next);
    emit('change', next);
  }
  // keep ready for next selection
  searchTerm.value = '';
  open();
  activeIndex.value = 0;
}

function removeValue(val: any) {
  const current = Array.isArray(props.modelValue) ? props.modelValue : [];
  const next = current.filter(v => v !== val);
  emit('update:modelValue', next);
  emit('change', next);
  touched.value = true;
}

function clearAll() {
  emit('update:modelValue', []);
  emit('change', []);
  touched.value = true;
}

function clearSearch() {
  searchTerm.value = '';
}

function onBlur() {
  setTimeout(() => { touched.value = true; }, 0);
}

function move(step: number) {
  if (!showList.value) {
    open();
    activeIndex.value = 0;
    return;
  }
  const n = filteredOptions.value.length;
  if (n === 0) return;
  activeIndex.value = (activeIndex.value + step + n) % n;

  requestAnimationFrame(() => {
    const list = document.getElementById(listId);
    const items = list?.querySelectorAll('.list-group-item');
    const el = items?.[activeIndex.value] as HTMLElement | undefined;
    el?.scrollIntoView({ block: 'nearest' });
  });
}

function commitActive() {
  const option = filteredOptions.value[activeIndex.value];
  if (option) selectOption(option);
  else close();
}

// Safety: if parent sends null, normalize to []
watch(
  () => props.modelValue,
  (v) => {
    if (!Array.isArray(v)) emit('update:modelValue', []);
  },
  { immediate: true }
);

// click-outside to close
function onDocClick(e: MouseEvent) {
  if (!rootEl.value) return;
  if (!rootEl.value.contains(e.target as Node)) close();
}
onMounted(() => document.addEventListener('mousedown', onDocClick));
onBeforeUnmount(() => document.removeEventListener('mousedown', onDocClick));

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_b_list_group_item = _resolveComponent("b-list-group-item")!
  const _component_b_list_group = _resolveComponent("b-list-group")!
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback")!

  return (_openBlock(), _createElementBlock("div", {
    class: "position-relative",
    ref_key: "rootEl",
    ref: rootEl
  }, [
    (selectedRows.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("small", _hoisted_3, " Seleccionados (" + _toDisplayString(selectedRows.value.length) + ") ", 1),
            _createVNode(_component_b_button, {
              size: "sm",
              variant: "outline-danger",
              class: "rounded-0",
              disabled: _ctx.disabled,
              onClick: clearAll
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Limpiar todo ")
              ]),
              _: 1
            }, 8, ["disabled"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedRows.value, (r, i) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: String(r.value)
                  }, [
                    _createElementVNode("td", _hoisted_7, _toDisplayString(i + 1), 1),
                    _createElementVNode("td", _hoisted_8, _toDisplayString(r.text), 1),
                    _createElementVNode("td", _hoisted_9, [
                      _createVNode(_component_b_button, {
                        size: "sm",
                        variant: "outline-danger",
                        class: "rounded-0",
                        disabled: _ctx.disabled,
                        onClick: ($event: any) => (removeValue(r.value))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" Quitar ")
                        ]),
                        _: 2
                      }, 1032, ["disabled", "onClick"])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_b_form_input, {
      modelValue: searchTerm.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchTerm).value = $event)),
      placeholder: _ctx.placeholder,
      class: "mb-0 shadow-none fw-semibold rounded-0 pe-5",
      autocomplete: "off",
      role: "combobox",
      "aria-expanded": showList.value ? 'true' : 'false',
      "aria-controls": listId,
      onFocus: open,
      onClick: open,
      onInput: onInput,
      onKeydown: [
        _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (move(1)), ["prevent"]), ["down"])),
        _cache[2] || (_cache[2] = _withKeys(_withModifiers(($event: any) => (move(-1)), ["prevent"]), ["up"])),
        _withKeys(_withModifiers(commitActive, ["prevent"]), ["enter"]),
        _withKeys(_withModifiers(close, ["prevent"]), ["esc"])
      ],
      state: inputState.value,
      onBlur: onBlur,
      disabled: _ctx.disabled
    }, null, 8, ["modelValue", "placeholder", "aria-expanded", "onKeydown", "state", "disabled"]),
    (searchTerm.value && !_ctx.disabled)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          type: "button",
          class: "btn-close position-absolute top-50 end-0 translate-middle-y me-2",
          style: {"padding-right":"3rem","right":"4.5rem"},
          "aria-label": "Clear",
          onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop","prevent"])),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (clearSearch()))
        }, null, 32))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_b_list_group, {
      id: listId,
      class: "position-absolute w-100 bg-white border rounded shadow",
      style: {"z-index":"1051","max-height":"200px","overflow-y":"auto","top":"100%","left":"0"}
    }, {
      default: _withCtx(() => [
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_b_list_group_item, {
              key: 0,
              disabled: ""
            }, {
              default: _withCtx(() => [
                _hoisted_10,
                _createTextVNode(" Cargando... ")
              ]),
              _: 1
            }))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredOptions.value, (option, idx) => {
                return (_openBlock(), _createBlock(_component_b_list_group_item, {
                  key: String(option.value),
                  button: "",
                  class: _normalizeClass({
            active: idx === activeIndex.value,
            'opacity-50': isSelected(option.value)
          }),
                  onMousemove: ($event: any) => (activeIndex.value = idx),
                  onMousedown: _withModifiers(($event: any) => (selectOption(option)), ["prevent"])
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(option.text), 1),
                      (isSelected(option.value))
                        ? (_openBlock(), _createElementBlock("small", _hoisted_12, "✓"))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["class", "onMousemove", "onMousedown"]))
              }), 128)),
              (filteredOptions.value.length === 0)
                ? (_openBlock(), _createBlock(_component_b_list_group_item, {
                    key: 0,
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Sin resultados ")
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    }, 512), [
      [_vShow, showList.value]
    ]),
    (isInvalid.value)
      ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, { key: 2 }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(invalidText.value), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 512))
}
}

})